import React, { useState, useEffect } from "react";
import { Box, DataGrid, SelectBox } from "devextreme-react";
import { Item } from "devextreme-react/box";
import http from "../../utils/http";
import uri from "../../utils/uri";
import { store } from "../../services/store";
import { Column, Editing, Form, Paging, Popup, RequiredRule, StringLengthRule } from "devextreme-react/data-grid";
import BlockHeader from '../../components/shared/BlockHeader';
import Title from "../../components/shared/Title";

const ToroidalContacts = props => {

    const title = "Tabla de conversion Lentes Toricos";

    return (
        <div className="container small">
            <Title title={title} />
            <BlockHeader title={title} />
            <DataGrid
                dataSource={store({ uri: { get: uri.toroidalContacts.get, insert: uri.toroidalContacts.insert } })}
                showBorders={true}
                showRowLines={true}
            >
                <Paging defaultPageSize={22} />
                <Editing
                    mode="popup"
                    allowUpdating={true}
                    allowDeleting={false}
                    allowAdding={false}
                    useIcons={true}

                >
                    <Popup width={600} height={200}>
                    </Popup>
                    <Form>
                        <Item dataField="sphere" editorOptions={{ width: 200 }} />
                        <Item dataField="cilinder" editorOptions={{ width: 200 }} />
                        <Item dataField="value" editorOptions={{ width: 200 }} >
                            <RequiredRule message="El valor es requerido" />
                            <StringLengthRule max={15} min={3} message="Máximo de caracteres 15 y 3 mínimo" />
                        </Item>
                    </Form>
                </Editing>
                <Column dataField="sphere" caption="Esfera" width="30%" allowEditing={false} />
                <Column dataField="cilinder" caption="Cilindro" width="30%" allowEditing={false} />
                <Column dataField="value" caption="Valor" width="40%" />
            </DataGrid>

        </div>
    );
}

export default ToroidalContacts;